import { EntityIcon } from '@components/core-ui/EntityIcon/';
import { routes } from '@routes';
import { MeResponseDtoOrganization } from 'app/API';
import { Link as RouterLink } from 'react-router-dom';

export type TProps = {
  org: MeResponseDtoOrganization;
  handleOrganizationClick: (org: MeResponseDtoOrganization) => void;
};

export const OrganizationRow = ({ org, handleOrganizationClick }: TProps) => {
  return (
    <li className="h-9 cursor-pointer text-foreground-muted text-base hover:bg-surface-muted flex flex-row">
      <RouterLink
        to={routes.dashboard.make(org.slug)}
        onClick={() => handleOrganizationClick(org)}
        title={org.name}
        className="text-foreground-muted rounded-[5px] flex w-full items-center px-2.5 py-[5px] m-0 font-medium text-xs leading-[130%] relative cursor-pointer no-underline"
      >
        <EntityIcon name={org.name} src={org.image ?? undefined} className="mx-[6px] ml-0.5" />
        <span className="w-full whitespace-nowrap overflow-hidden text-ellipsis leading-7">{org.name}</span>
      </RouterLink>
    </li>
  );
};
